window.SETTINGS.domScan.addContainer( null, ($scanContainer) => {

	window.SETTINGS.domScan.addElement($scanContainer, '[data-modal-link]', function(){

		let openScrollPos;

		let player = null;
		let plyrInstance = null;
		let $target = $(this);
		let $closeModalGoop;

		let args = {
			before_open: function(){

				window.vent.trigger('closeModal');
				window.vent.trigger('modalOpen');

				openScrollPos = $(window).scrollTop();

				$('body').addClass('no-scroll');

				TweenMax.set($('#main .main-inner-wrapper'), {y:-openScrollPos});
				TweenMax.set($('#primary-content-wrapper'), {width: window.SETTINGS.coords.docWidth});
				TweenMax.set($('.is-fixed'), {y: openScrollPos});
			},
			// if video
			after_open: function(){

				let $modal = $('.modaal-wrapper');
				let $plyr = $modal.find('.modal-video-player .plyr-video');

				if ( $plyr.length ) {

					let $modalVideoPlayer = $modal.find('.modal-video-player');
					let $player           = $plyr.find('.player');
					let $domData          = $plyr.find('.dom-data');
					let controlsTemplate  = $plyr.find('#plyr__controls_template').html();
					let id                = $domData.attr('data-plyr-video-id');
					let provider          = $domData.attr('data-plyr-video-provider');
					let autostart         = $domData.attr('data-plyr-autostart') === 'true';

					$player.attr('data-type', provider);
					$player.attr('data-video-id', id);

					if(window.SETTINGS.breakpoint.maxWidth('screen-medium')){
						autostart = false;
					}

					player = plyr.setup($plyr, {
						clickToPlay: false,
						disableContextMenu: true,
						hideControls: false,
						html: controlsTemplate,
						autoplay: autostart
					});

					player[0].on('ready', (e) => {

						plyrInstance = e.detail.plyr;

						plyrInstance.on('playing', (e) => {
							console.log("is playing", $player.find('.plyr__controls'));
							$modalVideoPlayer.find('.plyr__controls').addClass('is-playing');
						});
					});
				}

				$('.modaal-wrapper .close-modal').off('click');
				$('.modaal-wrapper .close-modal').on('click', () => {
					window.vent.trigger('closeModal');
				});

				window.vent.trigger('domUpdate');
				$closeModalGoop = $('.modaal-wrapper .close-modal-goop .close-modal');
			},
			before_close: function() {

				if(plyrInstance){
					plyrInstance.destroy();
				}

				console.log('>>> player removed');

				$('body').css('cursor', '');
			},
			after_close: function() {

				$('body').removeClass('no-scroll');

				TweenMax.set($('#main .main-inner-wrapper'), {clearProps:'y'});
				TweenMax.set($('#primary-content-wrapper'), {clearProps:'width'});
				TweenMax.set($('.is-fixed'), {clearProps: 'y'});
				$(window).scrollTop(openScrollPos);

				window.vent.trigger('modalClose');
			}
		};

		let onCloseModal = () => {
			if($('.modaal-wrapper').length){
				$target.modaal('close');
			}
		}

		window.vent.on('changePageContent', onCloseModal, this);
		window.vent.on('closeModal', onCloseModal, this);

		if ( $target.attr('data-modal-args') ) {

			let lamma = $target.attr('data-modal-args').split(',');

			for ( let l of lamma ) {
				let str = l.split(':');
				args[str[0]] = str[1];
			}
		}

		$target.attr('data-modaal-href', '#modal--' + $target.attr('data-modal-link'));
		$target.modaal(args);

		$('.close').on('click', function(e){
			if($target && $target.length){
				$target.modaal('close');
			}
		});

	});

	/*

	window.SETTINGS.domScan.addElement($scanContainer, '[data-inline-popup]', function(){

		let $this		= $(this);
		let $fixedElems	= $('#header, #mobile-header, .affix');
		let regWinWidth	= 0;
		let modalId 	= $this.attr('href').substr(1);

		// resize handler for width shifts in fixed elements

		window.vent.on('windowResize', onWindowResize);
		onWindowResize();

		function onWindowResize(){
			regWinWidth = window.SETTINGS.coords.winWidth;
		}

		// track which modal has been opened for modal trigger button

		$this.on('click', function(e){

			window.SETTINGS.vars.$modalTriggerButton = $this;

			if(typeof($this.attr('data-modal-link-back')) !== 'undefined'){
				window.SETTINGS.vars.$modalOriginTriggerButton = $('[href=\"#' + $this.attr('data-modal-link-back') +  '\"]').eq(0);
			}

			window.requestAnimationFrame(function(){
				window.vent.trigger('windowResize');
			});
		});

		//

		$this.magnificPopup({

			overflowY: 'scroll', // as we know that popup content is tall we set scroll overflow by default to avoid jump, mostly in cases of modals in short windows cutting off the close btn if placed outside the modal
			// removalDelay: 500, //delay removal by X to allow out-animation
			midClick: true, // allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source.

			fixedContentPos: true,

			callbacks: {

				beforeOpen: function(e) {

					let attr			= this.st.el.attr('data-effect');
					this.st.mainClass	= typeof attr !== typeof undefined && attr !== false ? attr : 'mfp-fade-in';

					window.vent.trigger('modalBeforeOpen', {$target: $this, modalId:modalId});
				},

				open: function() {

					let $content = this.content;

					$fixedElems.css({'width': 'calc(100% - ' + (window.innerWidth - regWinWidth) + 'px)'});

					window.vent.trigger('modalOpen', {$target: $content, modalId: modalId, $link: $this});
					window.vent.trigger('domUpdate', {$scanContainer: $content});
					window.vent.trigger('windowResize', {$scanContainer: $content});
				},

				beforeClose: function () {

				},

				close: function() {

					let $this = this.content;

					$fixedElems.css({'width': ''});

					window.vent.trigger('modalClose', {$target: $this, modalId:modalId});
				},

				afterClose:function(){
					window.vent.trigger('modalAfterClose', {$target: $this, modalId:modalId});
				}
			}
		});

	});

	// compare modal

	window.SETTINGS.domScan.addElement($scanContainer, '.mfp-close', function(){

		$(this).on('click', () => {
			$.magnificPopup.close();
		});
	});

	*/

});
